import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { PageNotFoundModule } from '@shared/lib/modules/page-not-found/page-not-found.module';
import { ContentStackLoadingStatus, MarketingTemplateComponent } from '@usana/ux/cms';
import { map } from 'rxjs/internal/operators/map';

@Component({
  selector: 'u-dc-u-cms-home',
  imports: [MarketingTemplateComponent, PageNotFoundModule],
  templateUrl: './cms-home.component.html',
})
export class CmsHomeComponent {
  private readonly route = inject(ActivatedRoute);

  showNotFound = false;

  url = toSignal(
    this.route.url.pipe(
      map((segments: UrlSegment[]): string => {
        const childPath = segments.map((s: UrlSegment): string => s.path).join('/');
        // Prepend /mkt to get the full Contentstack URL
        return '/mkt/' + childPath;
      }),
    ),
  );

  statusChanged(status: ContentStackLoadingStatus): void {
    this.showNotFound = status === ContentStackLoadingStatus.NOT_FOUND;
  }
}
